import { render, staticRenderFns } from "./MspForsageOrdersForm.vue?vue&type=template&id=786c24e3"
import script from "./MspForsageOrdersForm.vue?vue&type=script&lang=js"
export * from "./MspForsageOrdersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports